// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_user_user_module_ts":"76ef7cd5434e6a09","src_app_suite-search_suite-search_module_ts":"3e0114b2e5d8c717","src_app_suite-reports_suite-reports_module_ts":"ce526f8c9b10048b","node_modules_xlsx_dist_xlsx_mini_min_js":"77d5d792c29fc3de","node_modules_xlsx_xlsx_js":"1b0fcc71f41baa1d"}[chunkId] + ".js";
};